import { render, staticRenderFns } from "./AboutMeApp.vue?vue&type=template&id=4122f3c6&"
import script from "./AboutMeApp.vue?vue&type=script&lang=js&"
export * from "./AboutMeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports